import { render, staticRenderFns } from "./BlogAccordion.vue?vue&type=template&id=11756288"
import script from "./BlogAccordion.vue?vue&type=script&lang=ts"
export * from "./BlogAccordion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports